<template>
  <v-text-field
    outlined
    dense
    v-model="time"
    hide-details
    min="01:00"
    max="03:00"
    type="time"
    step="0.001"
    label="Result Time"
    hint=":mm:ss.mis"
  ></v-text-field>
</template>
<script>
export default {
  data() {
    return {
      time: ""
    };
  },
  watch: {
    time(value) {
      console.log(value);
    }
  }
};
</script>
